import { render, staticRenderFns } from "./PanelFour.vue?vue&type=template&id=ed9d1068&scoped=true&"
import script from "./PanelFour.vue?vue&type=script&lang=js&"
export * from "./PanelFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9d1068",
  null
  
)

export default component.exports